<template>
    <div>
        <div class="row justify-content-center">
            <div class="col-10">
                <div class="text-left section-title" style="padding: 5px;">
                    <span class="row-table-font-margins" style='font-family: inherit; font-weight: 600 ; line-height: 1; text-align:center'>Settings</span>
                </div>
            </div>

        </div>
        <div class="row" style="padding-left: 15px; padding-right: 15px;">
            <div class="col-6 offset-3">
                <div class="container form-background">
                    <div class="row">
                        <div class=" col-12 text-left form-title">
                            <span class="row-table-font-margins">{{ formTitle }}</span>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-md-12">
    
                            <img :src="imageUrl" alt="avatar" style="max-width:200px;max-height:120px">
   
                        </div>
                    </div>
    <div class="row">
        <div class="col-md-12">
            <label>Company Logo:</label>
            <FileUpload name="demo[]" :customUpload="true" @uploader="myUploader" :multiple="false" accept="image/*" :maxFileSize="2000000">
                <template #empty>
                    <p>Drag and drop files to here to upload.</p>
                </template>
            </FileUpload>
        </div>

    </div>

    <div class="row">
        <div class="col-md-6">
            <label>Company Name:</label>
            <input type="text" v-model="invoiceName" placeholder="Company name" class="form-control" />
            <div v-if="submitted && !invoiceName" class="invalid-feedback">Invoice name is required</div>
        </div>
        <div class="col-md-12">
            <label>Invoice Address:</label>
            <textarea type="text" row="3" class="form-control" v-model="invoiceAddress"></textarea>
            <div v-if="submitted && !invoiceAddress" class="invalid-feedback">Invoice Address is required</div>
        </div>

    </div>

    <div class="row">
        <div class="col-md-6">
            <label>Use Monthly Expenses:</label>
            <input type="checkbox"
                   name="useMonthlyExpenses"
                   v-model="useMonthlyExpenses" />
        </div>
    </div>

    <div class="row" style="margin-top: 20px;">
        <div class="col-md-12">
            <label><strong>Monthly fees</strong></label>
            <p style="font-size: 13px; color: #6c757d; margin-bottom: 8px;">
                Monthly fees are created for a unit when it is added, for that year only.
                Choose a year and press the button to create any months that are missing for all units in your buildings.
                Existing months and the payments recorded against them are never changed.
            </p>
        </div>
        <div class="col-md-4">
            <select class="form-control" v-model.number="feesYear" :disabled="generatingFees" aria-label="Year">
                <option v-for="year in feeYears" :key="year" :value="year">{{ year }}</option>
            </select>
        </div>
        <div class="col-md-8">
            <button type="button" class="btn btn-submit" :disabled="generatingFees" @click="regenerateMonthlyFees()">
                {{ generatingFees ? "Generating..." : "Regenerate monthly fees" }}
            </button>
        </div>
        <div class="col-md-12" style="margin-top: 10px;">
            <div v-if="feesMessage" class="alert alert-success" role="status">{{ feesMessage }}</div>
            <div v-if="feesError" class="alert alert-danger" role="alert">{{ feesError }}</div>
        </div>
    </div>

    </div>

    <div class="text-right">
        <button type="submit" @click="submit()" class="btn btn-submit" style="margin: 15px;">
            Submit
        </button>
        <button @click="$router.go(-1)" class="btn btn-cancel">Cancel</button>
    </div>
    </div>

    </div>


    </div>
</template>
<script>
import { useVuelidate } from '@vuelidate/core';
    import { sameAsField } from '@/_helpers/validators';
    import { authenticationService } from "@/_services";
    import { Role } from '@/_helpers';
    import FileUpload from 'primevue/fileupload';
export default {
  data: function () {
    return {
            currentUser: null,
            invoiceName: "",
            invoiceAddress: "",
            username: "",
            password: "",
            confirmPassword: "",
            useMonthlyExpenses:false,
            email: "",
            role: "Management",
            formTitle: "Edit Settings",
            id: 0,
            numberOfBuildings: 0,
        submitted: false,
        imageUrl: "",
            feesYear: new Date().getFullYear(),
            generatingFees: false,
            feesMessage: "",
            feesError: "",
            };
        },

        components: {
            FileUpload
        },

    created() {
            authenticationService.currentUser.subscribe((x) => (this.currentUser = x));
        },
    setup: () => ({ v$: useVuelidate() }),
    validations: {
        confirmPassword: { sameAsPassword: sameAsField('password') }
    },
      mounted() {
    
        this.getUserSetting();
    
      },
        computed: {
            feeYears() {
                const current = new Date().getFullYear();
                return [current - 1, current, current + 1, current + 2];
            },
        },
        methods: {
            regenerateMonthlyFees() {
                const message = "Create any missing monthly fees for " + this.feesYear + " for all units in your buildings?\n\nExisting months and payments will not be changed.";
                if (!window.confirm(message)) return;
                this.feesMessage = "";
                this.feesError = "";
                this.generatingFees = true;
                this.$http
                    .post("/properties/regenerateMonthlyFees", { userId: this.currentUser.id, year: this.feesYear })
                    .then(({ data }) => {
                        this.feesMessage =
                            data.created > 0
                                ? "Created " + data.created + " monthly fee(s) for " + data.unitsUpdated + " of " + data.unitsChecked + " unit(s) in " + data.year + "."
                                : "Nothing to create: all " + data.unitsChecked + " unit(s) already have monthly fees for " + data.year + ".";
                    })
                    .catch((error) => {
                        this.feesError =
                            (error.response && typeof error.response.data === "string" && error.response.data) ||
                            "The monthly fees could not be created. Please try again.";
                    })
                    .finally(() => {
                        this.generatingFees = false;
                    });
            },
            myUploader(event) {
               
                const formData = new FormData();
                formData.append("formFile", event.files[0])
                formData.append("fileName", event.files[0].name)
                formData.append("userId", this.currentUser.id)
               
                this.$http.post("/usersettings/uploadimage", formData, {
                                    headers: {
                                      'Content-Type': 'multipart/form-data'
                                    }
                                }
                    ).then(response => {
                       // alert("Total Mock File Uploaded: ${response.data}");
                        this.imageUrl = response.data.logo
                        
                    }).catch(error => {
                        alert(`something went wrong: ${error}`);
                    });
            },

            onUpload() {
                this.$toast.add({ severity: 'info', summary: 'Success', detail: 'File Uploaded', life: 3000 });
            },

            getUserSetting: function () {
                this.$http.get("/usersettings/" + this.currentUser.id)
                    .then((response) => {
                                this.invoiceAddress = response.data.settings.invoiceAddress
                        this.invoiceName = response.data.settings.invoiceName
                        this.useMonthlyExpenses = response.data.settings.useMonthlyExpenses
                        this.imageUrl = response.data.logo
                    })
                    .catch((error) => {
                        alert(`something went wrong: ${error}`);
                    });
                },
    
            submit: function () {
             this.$http
                    .post("/usersettings/updatesettings", {
                    userId: this.currentUser.id,
                        invoiceAddress: this.invoiceAddress,
                        invoiceName: this.invoiceName,
                        useMonthlyExpenses: this.useMonthlyExpenses,
           
                  })
                  .then(
                      () => {
                          this.$router.go(-1)
                    },
                    () => {
                      alert("error");
                      //  this.infoError = true
                      //  this.loader = false
                      this.password = "";
                    }
                  );
            },
      },
    };
</script>